module.exports = __webpack_public_path__ + "img/cocacola.e493d5ad.png";